import { Link, Head } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import TeacherShell from '../../components/layout/TeacherShell';
import { Card } from '../../components/ui';
import { cn } from '../../lib/cn';

const typeColors = {
  awl: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
  curated: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
  sat: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
  gre: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
  ngsl: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  academic: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400',
  generated: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-400',
  custom: 'bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-400',
};

export default function VocabularyListsIndex({ lists }) {
  const { t } = useTranslation();
  return (
    <TeacherShell scrollTitle={t('vocabLists.title')}>
      <Head title={t('vocabLists.title')} />

      <div className="max-w-5xl mx-auto px-4 py-8">
        {/* Header */}
        <header className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                {t('vocabLists.title')}
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mt-2">
                {t('vocabLists.subtitle')}
              </p>
            </div>
            <Link
              href="/teacher/dictionary"
              className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
            >
              {t('vocabLists.browseDictionary')}
            </Link>
          </div>
        </header>

        {/* Lists Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {lists.map((list) => (
            <Link key={list.id} href={`/teacher/vocabulary_lists/${list.id}`}>
              <Card className="p-5 h-full hover:shadow-md transition-shadow">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="font-semibold text-gray-900 dark:text-white">
                    {list.name}
                  </h3>
                  <span className={cn(
                    'px-2 py-0.5 text-xs font-medium rounded',
                    typeColors[list.listType] || typeColors.curated
                  )}>
                    {list.listType}
                  </span>
                </div>
                {list.description && (
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-3 line-clamp-2">
                    {list.description}
                  </p>
                )}
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-500 dark:text-gray-400">
                    {list.wordCount} {t('common.words')}
                  </span>
                  {list.source && (
                    <span className="text-gray-400 dark:text-gray-500">
                      {list.source}
                    </span>
                  )}
                </div>
              </Card>
            </Link>
          ))}
        </div>

        {lists.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500 dark:text-gray-400">
              {t('vocabLists.noLists')}
            </p>
          </div>
        )}
      </div>
    </TeacherShell>
  );
}
